<template>
  <a-dialog ref="dialog" name="edit_customer_payment_method" :loading="loading" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <div>{{ $t('payment-method') }}
        <strong>{{ $t('payment-authorisation') }}</strong>
      </div>
      <a-payment-method-form
        ref="form"
        @valid="onFormValid"
        @message="onFormMessage"
      >
      </a-payment-method-form>
    </div>
    <span slot="actions">
      <v-btn color="success" text @click="submit" :disabled="!valid">
        <v-icon left>mdi-lock</v-icon>
        {{ $t('actions.edit') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'EditCustomerPaymentMethodDialog',
  data () {
    return {
      loading: '',
      valid: false,
    }
  },
  methods: {
    onFormValid (valid) {
      this.valid = valid
    },
    onFormMessage (message) {
      this.loading = message
    },
    submit () {
      this.$refs.form.save()
        .then(message => {
          this.$ui.success(message)
          if (this.$refs.dialog) this.$refs.dialog.close()
        })
        .catch(err => {
          this.$ui.error(err)
        })
        .finally(() => this.loading = '')
    }
  }
}
</script>

<i18n>
{
	"en": {
		"payment-authorisation": "In order to validate the correct functioning of your card, a payment authorization of 0,00 € will be asked during the confirmation.",
		"payment-method": "Enter below the default payment method that will be used on your account.",
		"title": "Payment method"
	},
	"es": {
		"payment-authorisation": "Para validar el correcto funcionamiento de su tarjeta, se le pedirá una autorización de pago de 0,00 € durante el proceso de confirmación.",
		"payment-method": "Ingrese el método de pago predeterminado a continuación que se utilizará en su cuenta.",
		"title": "Medios de pago"
	},
	"fr": {
		"payment-authorisation": "Afin de valider le bon fonctionnement de votre carte, une autorisation de paiement de 0,00 € vous sera demandé pendant la confirmation.",
		"payment-method": "Saisissez ci-dessous le moyen de paiement par défaut qui sera utilisé sur votre compte.",
		"title": "Moyen de paiement"
	},
	"it": {
		"payment-authorisation": "Per validare il corretto funzionamento della tua carta, verrà richiesta un'autorizzazione di pagamento di 0,00 € durante la conferma.",
		"payment-method": "Inserisci di seguito il metodo di pagamento predefinito che verrà utilizzato sul tuo account.",
		"title": "Metodo di pagamento"
	},
	"pt": {
		"payment-authorisation": "Para validar o correto funcionamento do seu cartão, será pedida uma autorização de pagamento de 0,00 € durante a confirmação.",
		"payment-method": "Introduza abaixo o método de pagamento predefinido que será utilizado na sua conta.",
		"title": "Método de pagamento"
	},
	"pl": {
		"payment-authorisation": "W celu sprawdzenia prawidłowego działania karty, podczas potwierdzania zostanie złożona autoryzacja płatności 0,00 €.",
		"payment-method": "Wprowadź poniżej domyślną metodę płatności, która będzie używana na Twoim koncie.",
		"title": "Metoda płatności"
	}
}
</i18n>

